(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('painelCriarMapa', PainelCriarMapaDirective);

  function PainelCriarMapaDirective() {
    return {
      restrict: 'E',
      controller: 'PainelCriarMapaCtrl',
      controllerAs: 'mapa',
      templateUrl: 'views/propriedade/painel-criar-mapa.html'
    };
  }
}());
